import { RootState } from '@store/index'

export const selectPaymentMethods = (state: RootState) => state.appDataState.appData.payment_methods

export const walletHistorySelector = (state: RootState) => state.walletState.walletHistory
